import {
  ExportTotalWashingCountByRangeDayRequest,
  ExportTotalWashingCountByRangeDayResponse,
  GetTotalWashingCountByRangeDayRequest,
  GetTotalWashingCountByRangeDayResponse,
  GetWashingCountByDayRequest,
  GetWashingCountByDayResponse,
} from '@/types/apis/washingCount'
import { ExportWashingCountByDayRequest } from '@/types/apis/washingCount/ExportWashingCountByDayRequest'
import { ExportWashingCountByDayResponse } from '@/types/apis/washingCount/ExportWashingCountByDayResponse'
import { ExportWashingCountByRangeDayRequest } from '@/types/apis/washingCount/ExportWashingCountByRangeDayRequest'
import { ExportWashingCountByRangeDayResponse } from '@/types/apis/washingCount/ExportWashingCountByRangeDayResponse'
import { GetWashingCountByRangeDayRequest } from '@/types/apis/washingCount/GetWashingCountByRangeDayRequest'
import { GetWashingCountByRangeDayResponse } from '@/types/apis/washingCount/GetWashingCountByRangeDayResponse'

import axios from './axios'

const API_ENDPOINT = '/laundry'

export const getWashingCountByDay = (request: GetWashingCountByDayRequest): Promise<GetWashingCountByDayResponse> => {
  return axios.get(`${API_ENDPOINT}/washing-machine-by-date`, { params: request })
}

export const getWashingCountByRangeDay = (
  request: GetWashingCountByRangeDayRequest
): Promise<GetWashingCountByRangeDayResponse> => {
  return axios.get(`${API_ENDPOINT}/washing-machine-by-range-date`, { params: request })
}

export const getTotalWashingCountByRangeDay = (
  request: GetTotalWashingCountByRangeDayRequest
): Promise<GetTotalWashingCountByRangeDayResponse> => {
  return axios.get(`${API_ENDPOINT}/washing-machine-total-by-range-date`, { params: request })
}

export const exportWashingCountByDay = (
  request: ExportWashingCountByDayRequest
): Promise<ExportWashingCountByDayResponse> => {
  return axios.get(`${API_ENDPOINT}/export-washing-machine-by-date`, { params: request })
}

export const exportWashingCountByRangeDay = (
  request: ExportWashingCountByRangeDayRequest
): Promise<ExportWashingCountByRangeDayResponse> => {
  return axios.get(`${API_ENDPOINT}/export-washing-machine-by-range-date`, { params: request })
}

export const exportTotalWashingCountByRangeDay = (
  request: ExportTotalWashingCountByRangeDayRequest
): Promise<ExportTotalWashingCountByRangeDayResponse> => {
  return axios.get(`${API_ENDPOINT}/export-washing-machine-total-by-range-date`, { params: request })
}
